import { c as _c } from "react/compiler-runtime";
import { keycloakAuthoriseKeycloakDirectGrant } from '@/app/lib/rest';
import { QueryParams } from '@/helpers/filter';
import { TSRException } from '@/helpers/rest';
import { useRouter } from '@/i18n/routing';
import { DirectGrantAuthorisation } from '@diamond-block/api/v1/self-service/schema/keycloak';
import { IconSize } from '@diamond-block/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSession } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { FormProvider, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { TbInfoCircle } from 'react-icons/tb';
import { ErrorDisplay } from '../feedback/ErrorDisplay';
import { FormControl } from '../forms/FormControl';
export const KeycloakForm = () => {
  const $ = _c(49);
  const t = useTranslations("KeycloakForm");
  const {
    data: session
  } = useSession();
  const {
    push
  } = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(DirectGrantAuthorisation);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = session?.user?.email || undefined;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      resolver: t0,
      defaultValues: {
        email: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const loginForm = useForm(t2);
  const {
    handleSubmit,
    formState: t3
  } = loginForm;
  const {
    isSubmitting
  } = t3;
  let t4;
  if ($[3] !== push || $[4] !== t) {
    t4 = async credentials => await toast.promise(keycloakAuthoriseKeycloakDirectGrant({
      body: credentials
    }).then(_temp), {
      loading: t("authorising"),
      success: res_0 => {
        const params = new QueryParams({
          request: res_0.body.requestToken
        });
        setTimeout(() => push(`?${params.toString()}`), 1);
        return t("successfully-authenticated");
      },
      error: _temp2
    });
    $[3] = push;
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleSubmit || $[7] !== t4) {
    t5 = handleSubmit(t4);
    $[6] = handleSubmit;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      required: true
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("email");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("note");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TbInfoCircle size={IconSize.tooltip} className="text-primary inline" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <span className="tooltip tooltip-top tooltip-primary ml-2" data-tip={t8}>{t9}</span>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className="flex items-center">{t7}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("email-placeholder");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <FormControl options={t6} field="email" label={t11} placeholder={t12} type="email" />;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      required: true,
      minLength: 2
    };
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t) {
    t15 = t("password");
    $[26] = t;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t) {
    t16 = t("password-placeholder");
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t15 || $[31] !== t16) {
    t17 = <FormControl options={t14} field="password" label={t15} placeholder={t16} type="password" />;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== isSubmitting) {
    t18 = isSubmitting && <span className="loading loading-spinner" />;
    $[33] = isSubmitting;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t) {
    t19 = t("request");
    $[35] = t;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== isSubmitting || $[38] !== t18 || $[39] !== t19) {
    t20 = <div className="flex flex-row justify-end p-2"><button className="btn btn-primary" disabled={isSubmitting} type="submit">{t18}{t19}</button></div>;
    $[37] = isSubmitting;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t13 || $[42] !== t17 || $[43] !== t20 || $[44] !== t5) {
    t21 = <form onSubmit={t5}>{t13}{t17}{t20}</form>;
    $[41] = t13;
    $[42] = t17;
    $[43] = t20;
    $[44] = t5;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== loginForm || $[47] !== t21) {
    t22 = <FormProvider {...loginForm}>{t21}</FormProvider>;
    $[46] = loginForm;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  return t22;
};
function _temp(res) {
  if (res.status !== 201) {
    throw new TSRException(res);
  }
  return res;
}
function _temp2(err) {
  return <ErrorDisplay err={err} />;
}